import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router";
import { Home, Login } from "../components";

import { login, logout, selectUser } from "../features/userSlice";
import { useDispatch } from "react-redux";
import { auth } from "../config/firebase.config";
import { PostPage } from "../components/post-page/PostPage";
import { HomeMain } from "../components/HomeContents/HomeMain";
import { Notification } from "../components/Notifications/Notification";
import { Navbar } from "../components/Navbar/Navbar";
import Chat from "../components/sendMessage/Chat";

import PrivateRoute from "./PrivateRoute";
import { Link } from "react-router-dom";
import RestrictedRoute from "./RestrictedRoute";
import { PostData } from "../components/dbTest/PostData";
import { TextEditor } from "../components/post-page/Editor";
import { Error } from "../components/error/Error.jsx";
import Unanswered from "../components/unanswered/Unanswered";
import { FellowsPage } from "../components/Fellows/FellowsPage";
import { CommunityPage } from "../components/Communities/CommunityPage";
import { ExploreCommunities } from "../components/Communities/ExploreCommunities";
import { AdminPanel } from "../components/Admin/AdminPanel";
import { ProfilePage } from "../components/Profile/ProfilePage";
import { ensureUserProfile } from "../utils/verified";
import { useVerified } from "../context/VerifiedContext";

const Router = () => {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const [initializing, setInitializing] = useState(true);
    const { isSuperAdmin } = useVerified();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
                dispatch(login(firebaseUser));
                // Auto-seed scrubsmedina as SUPER_ADMIN + blue verified on first login.
                // Safe to call every login — only writes if doc is missing or outdated.
                ensureUserProfile(firebaseUser).catch(() => {});
            } else {
                dispatch(logout());
            }
            // Only set initializing to false AFTER Firebase has resolved auth state.
            // This prevents the brief redirect to /login on refresh.
            setInitializing(false);
        });
        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [dispatch]);

    // Show a full-page loading screen while Firebase is quietly restoring your session.
    // This is how Twitter, Instagram, etc. prevent the logout flash on refresh.
    if (initializing) {
        return (
            <div style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#faf7f2",
            }}>
                <span style={{
                    fontFamily: "'Pacifico', cursive",
                    fontSize: "48px",
                    color: "#1DA1F2",
                    letterSpacing: "1px",
                    animation: "pulse 1.5s ease-in-out infinite",
                }}>Fellora</span>
                <style>{`
                    @keyframes pulse {
                        0%, 100% { opacity: 1; }
                        50% { opacity: 0.4; }
                    }
                `}</style>
            </div>
        );
    }

    return (
        <Switch>
            {/* Restricted Route will not allow LoggedIn User to access login page */}

            <RestrictedRoute
                restricted={true}
                path="/login"
                component={Login}
                exact
            />
            <Route path="/" exact>
                {user ? <Redirect to="/home" /> : <Redirect to="/login" />}
            </Route>

            <Route path="/home" exact>
                {user ? (
                    <>
                        <Navbar />
                        <Home />
                    </>
                ) : (
                    <>
                        <Redirect to="/login" />
                    </>
                )}
            </Route>

            <Route exact path="/question/:question_id">
                {user ? (
                    <>
                        <Navbar />
                        <PostPage />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>

            <Route path="/notifications" exact>
                {user ? (
                    <>
                        <Navbar />
                        <Notification />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>

            <Route path="/chat" exact>
                {user ? (
                    <>
                        <Navbar />
                        <Chat />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="/answers" exact>
                {user ? (
                    <>
                        <Navbar />
                        <Unanswered />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="/fellows" exact>
                {user ? (
                    <>
                        <Navbar />
                        <FellowsPage />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="/c/:slug" exact>
                {user ? (
                    <>
                        <Navbar />
                        <CommunityPage />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="/communities" exact>
                {user ? (
                    <>
                        <Navbar />
                        <ExploreCommunities />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="/profile" exact>
                {user ? (
                    <>
                        <Navbar />
                        <ProfilePage />
                    </>
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="/admin" exact>
                {isSuperAdmin ? (
                    <>
                        <Navbar />
                        <AdminPanel />
                    </>
                ) : user ? (
                    <Redirect to="/home" />
                ) : (
                    <Redirect to="/login" />
                )}
            </Route>
            <Route path="*">
                {/* <Navbar /> */}
                <Error />
            </Route>
        </Switch>
    );
};

export default Router;
